<app-breadcrumb [master]="'Należności'" [parentName]="'Salda'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group (selectedTabChange)="onTabChange($event)" [(selectedIndex)]="selectedTab" >

  <mat-tab label="Dane">
    <button *ngIf="receivablesBalanceObject?.active" [disabled]="!(userPermissions | async)?.receivables.delete" mat-stroked-button color="primary"
            class="add-button" (click)="updateBalance(false)"><mat-icon>lock</mat-icon> Blokada salda</button>
    <button  *ngIf="!receivablesBalanceObject?.active" [disabled]="!(userPermissions | async)?.receivables.delete" mat-stroked-button color="primary"
            class="add-button" (click)="updateBalance(true)"><mat-icon>lock_open</mat-icon> Odblokuj saldo</button>
    <button  *ngIf="receivablesBalanceObject?.partnerFacility" [disabled]="!(userPermissions | async)?.receivables.write" mat-stroked-button color="primary"
             class="add-button" (click)="deletePartnerFacility()"><mat-icon>remove</mat-icon>Odepnij placówkę </button>
    <button  *ngIf="receivablesBalanceObject?.ofwca && receivablesBalanceObject?.partner" [disabled]="!(userPermissions | async)?.receivables.write" mat-stroked-button color="primary"
             class="add-button" (click)="deleteOfwca()"><mat-icon>remove</mat-icon>Odepnij OFWCA </button>
    <button  *ngIf="!receivablesBalanceObject?.partnerFacility && receivablesBalanceObject?.ofwca && !receivablesBalanceObject?.partner" [disabled]="!(userPermissions | async)?.receivables.write" mat-stroked-button color="primary"
             class="add-button" (click)="addPartnerFacility()"><mat-icon>add</mat-icon>Dodaj placówkę </button>
    <button  *ngIf="!receivablesBalanceObject?.ofwca && receivablesBalanceObject?.partner" [disabled]="!(userPermissions | async)?.receivables.write" mat-stroked-button color="primary"
             class="add-button" (click)="addOfwca()"><mat-icon>add</mat-icon>Dodaj OFWCA </button>

    <button   [disabled]="!(userPermissions | async)?.receivables.create && ((receivablesBalanceObject?.sumDeposits - receivablesBalanceObject?.sumPolicy) > 0)" mat-stroked-button color="primary"
             class="add-button" (click)="send(receivablesBalanceId)"><mat-icon>send</mat-icon> Wyślij przypomnienie</button>
    <button   [disabled]="!(userPermissions | async)?.receivables.create" mat-stroked-button color="primary"
              class="add-button" (click)="addNote()"><mat-icon>add</mat-icon> Dodaj notatkę</button>
    <button   [disabled]="!(userPermissions | async)?.receivables.admin_root" mat-stroked-button color="primary"
              class="add-button" (click)="restart(receivablesBalanceObject.uuid)"><mat-icon>restart_alt</mat-icon> Odśwież saldo</button>
    <app-receivables-balance-details-view
     [receivablesBalanceObject]="receivablesBalanceObject" [receivablesBalanceId]="receivablesBalanceId"
    >
    </app-receivables-balance-details-view>

  </mat-tab>

  <mat-tab label="Historia Salda">
    <ng-template matTabContent>

        <app-all-receivables-balance-history-list
          [receivablesBalanceId]="receivablesBalanceId" [embeddedView]="true"
        >
        </app-all-receivables-balance-history-list>
    </ng-template>
  </mat-tab>

  <mat-tab label="Polisy">
    <ng-template matTabContent>

        <app-all-receivables-imports-row-list
          [receivablesBalanceId]="receivablesBalanceId" [embeddedView]="true"
        >
        </app-all-receivables-imports-row-list>

    </ng-template>
  </mat-tab>

  <mat-tab label="Wpłaty">
    <ng-template matTabContent>
      <app-all-receivables-payment-import-row-list
        [showFilter]="false" [receivablesBalanceId]="receivablesBalanceId"  [embeddedView]="true"
        [displayedColumns]="['title', 'postingData', 'amount', 'statement', 'status']"
      >
      </app-all-receivables-payment-import-row-list>
    </ng-template>
  </mat-tab>

  <mat-tab label="Zestawienia">
    <ng-template matTabContent>
      <app-all-receivables-statement-list
        [showFilter]="false" [receivablesBalanceId]="receivablesBalanceId"  [embeddedView]="true"
        [displayedColumns]="['data', 'before', 'payments', 'returns', 'payouts', 'after', 'action']"
      >
      </app-all-receivables-statement-list>
    </ng-template>
  </mat-tab>

  <mat-tab label="Notatki">
    <ng-template matTabContent>
      <app-receivables-balance-note-list [receivablesBalanceNote]="receivablesBalanceNotes">
      </app-receivables-balance-note-list>
    </ng-template>
  </mat-tab>

  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list [receivablesBalance]="receivablesBalance"></app-log-list>
    </ng-template>
  </mat-tab>

<!--  <mat-tab label="OFWCA">-->
<!--    <ng-template matTabContent>-->
<!--      <app-all-receivables-balance-list-->
<!--        [showFilter]="false" [structure]="'ofwca'" [partnerId]="partnerId" [embeddedView]="true"-->
<!--        [displayedColumns]="['ofwca', 'pesel', 'partnerOFW', 'regional', 'sumOfwca']"-->
<!--      >-->
<!--      </app-all-receivables-balance-list>-->
<!--    </ng-template>-->
<!--  </mat-tab>-->

</mat-tab-group>
